import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

const HomepageBanner1 = () => {

  const scroll = () => {
    const section = document.querySelector("#services");
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div>
      <header className="header-area header-bg-9 style-09" id="home">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-6">
              <div className="header-inner">
                <h1 className="title wow fadeInDown">
                  Extend Your Product Team — Design and Frontend Engineering
                  That Ships
                </h1>
                <p>
                  We embed as your dedicated Product, UX, and Frontend
                  partner — built for healthcare, edtech, and HR tech teams
                  that need senior design and engineering without the
                  hiring cycle.
                </p>
                <div className="btn-wrapper wow fadeInUp">
                  <button
                    className="boxed-btn-02 reverse-color"
                    onClick={() => scroll()}
                  >
                    <i className="flaticon-apple-1"></i> Explore Services
                  </button>
                  <Link className="boxed-btn-02 blank" to="/contact-us">
                    <i className="flaticon-android-logo"></i> Get in touch
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default HomepageBanner1;
